import React from "react"

import { Link, withRouter } from "react-router-dom";
import moment from "moment";
import DateRangePicker from '@wojtekmaj/react-daterange-picker';

import BaseTable from "./BaseTable"
import Partner from "../modals/Partner";
import EditCell from "./cells/EditCell";
import DeleteCell from "./cells/DeleteCell";
import LinkCell from "./cells/LinkCell";

const TYPE_FILTERS = {
  name: {
    api: 'user_type',
    display: 'type',
  },
  values: [
    {
      label: 'All Users',
      value: "",
    },
    {
      label: 'Non-Registered Users',
      value: 'anonymous',
    },
    {
      label: 'Registered Users',
      value: 'registered',
    },
    {
      label: 'Pro Users',
      value: 'pro',
    },
  ],
}

class PartnersTable extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      live: props.live
    }

    this.table = React.createRef()
  }

  _getColumns(){
    return [
      {
        Header: 'Date',
        id: 'created_at',
        accessor: customer => moment(customer.created_at).format('DD MMM YYYY') || '-'
      },
      {
        Header: 'Name',
        id: 'customer.user.first_name',
        accessor: partner => `${partner.customer.user.first_name} ${partner.customer.user.last_name}`
      },
      {
        Header: 'Commission %',
        id: 'commission_percentage',
        accessor: partner => partner.commission_percentage * 100
      },
      {
        Header: 'Commission',
        id: 'commission_amount',
        accessor: partner => `€${partner.commission_amount * 100}`
      },
      {
        Header: 'Sign Ups',
        id: 'signup_no',
        accessor: 'signup_no'
      },
      {
        Header: 'Actions',
        sortable: false,
        exportable: false,
        headerClassName: 'text-end',
        Cell: rowInfo => {
          let partner = rowInfo.original
          return (
            <div className="text-end">
              <EditCell
                onEditClicked={() => this.setState({showPartnerModal: true, selectedPartner: partner})}
              />
              <LinkCell
                tooltip={"Copy App Link"}
                link={partner.referral_link}
              />
            </div>
          )
        }
      }
    ]
  }

  render() {
    let {
      selectedPartner,
      showPartnerModal
    } = this.state

    const columns = this._getColumns()

    return (
      <>
        <BaseTable
          ref={this.table}
          endpoint={`${window.Api.Partners}`}
          noDataMessage={"No partners found"}
          title={this.props.title}
          subtitle={this.props.subtitle}
          columns={columns}
          defaultSorted={[
            {
              id: "created_at",
              desc: true
            }
          ]}
          renderToolbar={() => (
            <>
              <div className="card-toolbar">
                <button
                  type="button"
                  className="btn btn-sm btn-outline btn-outline-dark btn-outline-dark btn-mw"
                  data-bs-toggle="" data-bs-target=""
                  onClick={() => this.setState({showPartnerModal: true})}
                >
                  <span>Add Partner</span>
                </button>
              </div>
            </>
          )}
          showPaginationBottom={!this.props.latestResults}
          showFilter={this.props.showFilter}
        />
        {
          showPartnerModal &&
          <Partner
            show={showPartnerModal}
            partner={selectedPartner}
            onSaved={() => {
              this.setState({showPartnerModal: false, selectedPartner: null})
              this.table.current.refresh()
            }}
            onHide={() => this.setState({showPartnerModal: false, selectedPartner: null})}
          />
        }
      </>
    )

  }

}

PartnersTable.defaultProps = {
  showFilter: true,
  latestResults: false
}

export default withRouter(PartnersTable);
